import Command from "@ckeditor/ckeditor5-core/src/command"

export default class AppAffiliateTemplateCommand extends Command {
  execute(options) {
    const id = options.id
    const name = options.name
    this.editor.model.change((writer) => {
      this.editor.model.insertContent(
        this.createAppAffiliateTemplate(writer, id, name)
      )
    })
  }

  refresh() {
    const model = this.editor.model
    const selection = model.document.selection
    const allowedIn = model.schema.findAllowedParent(
      selection.getFirstPosition(),
      "appAffiliateTemplateBox"
    )

    this.isEnabled = allowedIn !== null
  }

  // TODO schemaで定義したデータ構造を実際に作成する
  createAppAffiliateTemplate(writer, id, name) {
    const boxElement = writer.createElement("appAffiliateTemplateBox")
    const labelElement = writer.createElement("appAffiliateTemplateLabel")
    const nameElement = writer.createElement("appAffiliateTemplateName", {
      id: id,
    })
    writer.append(labelElement, boxElement)
    writer.append(nameElement, boxElement)
    writer.appendText("アプリアフィリエイトテンプレート", labelElement)
    writer.appendText(name, nameElement)
    return boxElement
  }
}
